import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";

export interface ITipsIconProps {
  tipsLabel: string;
  scale?: number;
  iconMargin?: number;
}

export const TipsIcon: React.FunctionComponent<ITipsIconProps> = (props) => {
  const { tipsLabel, scale = 1 } = props;

  const iconRef = useRef<HTMLElement>(null);

  // Whether the tip should appear to the left, center, or right of the icon
  // When the icon is near the edge of the viewport, the tip will slide to the left or right
  const [xPosition, setXPosition] = useState<"left" | "center" | "right">(
    "left"
  );

  // Whether the tip should appear above or below the icon
  const [yPosition, setYPosition] = useState<"top" | "bottom">("top");

  // Update position when scrolling, so that `position` is `bottom` when the icon
  // is in the top half of the viewport, and `top` when it is in the bottom half of the viewport
  useEffect(() => {
    const handleScroll = () => {
      const iconPosition = iconRef.current?.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;
      setYPosition(
        iconPosition && iconPosition > screenHeight / 2 ? "top" : "bottom"
      );
    };

    // Run once to set the default position
    handleScroll();

    // Add event listener for scrolling
    window.addEventListener("scroll", handleScroll);

    // Remove event listener on unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Update xPosition when the window is resized
  useEffect(() => {
    const handleResize = () => {
      const iconPosition = iconRef.current?.getBoundingClientRect().left;
      if (!iconPosition) return;

      const screenWidth = window.innerWidth;

      if (iconPosition > screenWidth / 2) {
        setXPosition("right");
      } else if (iconPosition < screenWidth / 2) {
        setXPosition("left");
      } else {
        setXPosition("center");
      }
    };

    // Run once to set the default position
    handleResize();

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Remove event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <span className="question-module">
      <i
        className="icons icon-question"
        ref={iconRef}
        style={{ transform: `scale(${scale})` }}
      ></i>
      <div className={`tips-container ${yPosition}`}>
        <span className={`tips-triangle tips-top-triangle ${yPosition}`} />
        <span className={`tips-label ${yPosition} ${xPosition}`}>
          {tipsLabel}
        </span>
        <span className={`tips-triangle tips-bottom-triangle ${yPosition}`} />
      </div>
    </span>
  );
};

export default TipsIcon;
